import { createContext } from 'react';

export type ToastVariant = 'success' | 'error' | 'info' | 'warning';

export type Toast = {
    id: string;
    title?: string;
    message: string;
    variant?: ToastVariant;
    duration?: number;
};

export type ToastContextValue = {
    show: (toast: Omit<Toast, 'id'>) => string;
    success: (message: string, opts?: Omit<Toast, 'id' | 'message' | 'variant'>) => string;
    error: (message: string, opts?: Omit<Toast, 'id' | 'message' | 'variant'>) => string;
    info: (message: string, opts?: Omit<Toast, 'id' | 'message' | 'variant'>) => string;
    warning: (message: string, opts?: Omit<Toast, 'id' | 'message' | 'variant'>) => string;
    dismiss: (id: string) => void;
};

export const ToastContext = createContext<ToastContextValue | null>(null);